import { getKey } from "../redux/actions/actionUtils";

export const inflightActionsSelector = (state) => state?.inflightActions;

export const isActionInflight = (state, action) =>
  (state?.inflightActions ?? []).includes(getKey(action));
